import React, {useState, useRef} from 'react';
import { connect } from 'react-redux';
import NotFoundPageHolder from './NotFoundPageStyles';
import SEO from '../../components/SEO/SEO';
import multilingual from "../../multilingual.json";
import { getLabel } from '../../utils';

const NotFoundPage = (props) => {
    const {
        current_lang,
        pages,
        redirects,
        episode
        } = props

    const [searchTerm, setSearchTerm] = useState("");
    const inputRef = useRef(null);
    const siteURL = window.location.origin;

    const title = () => multilingual["NOTFOUND_TITLE_"+current_lang]
    const body = () =>  multilingual["NOTFOUND_EXPLANATION_"+current_lang]
    const searchReq = () =>  multilingual["SEARCH_REQUEST_"+current_lang]
    const pageTitle = current_lang ==="en" ? "CPAC - Watch for Democracy" : "CPAC - Pour la démocratie";

    const searchTermChange = (e) => {
		setSearchTerm(e.target.value);
	}

    const handleKeyPress = (e) => {
		if (e.key === 'Enter' || e.keyCode === 13) {
			searchClickHandler(e);
		}
	}
    const searchClickHandler = (e) => {
		e.preventDefault();
		const searchUrl = current_lang === "en" ? "/search" : "/rechercher";
		window.location.href = `${searchUrl}?key=${searchTerm}`;
	}

    const search = () => {
        return(
            
            <div className="search-not-found">
                {searchReq()}
                <div className="search-container">
					<input
						aria-label={getLabel("SEARCH")}
						name={getLabel("SEARCH")}
						placeholder={getLabel("SEARCHPLACEHOLDER")}
						onChange={searchTermChange}
						onKeyDown={(e)=>handleKeyPress(e)}
						ref={ inputRef }
						type="text"
					></input>
					<button onClick={(e) => searchClickHandler(e)}>{getLabel("SEARCH")}</button>
				</div>
            </div>
        )
    }

    return(
        <>
        <SEO pageDesc={body()} pageURL={siteURL} title={pageTitle} pageTitle={pageTitle} image="" type="website" pageLocale={current_lang + '_CA'} robots="false" />
        <NotFoundPageHolder>
            {(props.pages && props.pages.length === 0) || (props.redirects && props.redirects.length === 0) || (props.episode && props.episode === null)  ? " " : 
            <>
            <div className="row">
                <h1 className="page-title">{title()}</h1>
            </div>
            <div className="article-bg">
                <div className="container">
                    <div className="entry-content cf">
                        <span className="content-title">{title()}</span>
                        <hr />
                        <div className="article-content">
                            {body()}
                            {search()}
                        </div>
                    </div>
                </div>
            </div>
            </>
            }
        </NotFoundPageHolder>
        </>
    )
}

const mapStateToProps = (store) => ({
    current_lang: store.language.current,
});

const mapDispatchToProps = (dispatch) => ({
    setCurrentLanguage: (lang) => dispatch({ type: 'SET_CUR_LANG', current: lang })
});

export default connect(mapStateToProps,mapDispatchToProps)(NotFoundPage);